import React from "react";
import "./help-icon.css";

function HelpIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.635"
        height="22.35"
        viewBox="0 0 23.635 22.35"
      >
        <defs></defs>
        <g transform="translate(-11.75 -14.25)">
          <g transform="translate(12 14.5)">
            <path
              className="a"
              d="M30.637,14.5H16.5A4.5,4.5,0,0,0,12,19v9a4.5,4.5,0,0,0,4.5,4.5h3.555l3.021,3.625a.642.642,0,0,0,.986,0l3.021-3.625h3.555a4.5,4.5,0,0,0,4.5-4.5V19A4.5,4.5,0,0,0,30.637,14.5ZM33.85,28a3.217,3.217,0,0,1-3.213,3.213H26.781a.642.642,0,0,0-.493.231L23.568,34.7l-2.72-3.263a.642.642,0,0,0-.493-.231H16.5A3.217,3.217,0,0,1,13.285,28V19A3.217,3.217,0,0,1,16.5,15.785H30.637A3.217,3.217,0,0,1,33.85,19Z"
              transform="translate(-12 -14.5)"
            />
            <path
              className="b"
              d="M45.285,50.5a1.285,1.285,0,1,0,1.285,1.285A1.285,1.285,0,0,0,45.285,50.5Zm0,1.284"
              transform="translate(-33.718 -38.932)"
            />
            <path
              className="b"
              d="M45.285,26.5A1.287,1.287,0,0,0,44,27.785v3.856a1.285,1.285,0,1,0,2.571,0V27.785A1.287,1.287,0,0,0,45.285,26.5Z"
              transform="translate(-33.718 -22.644)"
            />
          </g>
        </g>
      </svg>
    </>
  );
}

export default HelpIcon;
